import React from 'react';
import styles from './styles.module.scss';

export interface IStatusBarProps {
  averageIntensityThisWeek: number | string;
  cravingsThisWeek: number | string;
}

const StatusBar = ({
  averageIntensityThisWeek,
  cravingsThisWeek,
}: IStatusBarProps) => (
  <div className={styles.wrapper}>
    <div className={styles.header}>
      <div className={styles.value} data-testid="avg-intensity-for-period">
        {averageIntensityThisWeek}
      </div>
      <div className={styles.label}>
        Average intensity
        <br />
        this period
      </div>
    </div>
    <div className={styles.header}>
      <div className={styles.value} data-testid="number-of-cravings-for-period">
        {cravingsThisWeek}
      </div>
      <div className={styles.label}>
        # of cravings
        <br />
        this period
      </div>
    </div>
  </div>
);

export default StatusBar;
